import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { gridSpacing } from "../../store/constant";
import TaggingService from "../../services/TaggingService";
import HomePageService from "../../services/HomePage";
import * as Yup from "yup";
import axios from "axios";
import jsPDF from "jspdf";
import FormField from "../../ui-component/CustomTextField";
import MainCard from "../../ui-component/cards/MainCard";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
  fetchVehicleCategory,
  retriveStateList,
  retriveDistrictList,
} from "../../helper";
import {
  taggingFields,
  taggingInitials,
} from "../../formjson/tagDeviceToVehicle";
//import { MuiOtpInput } from "mui-one-time-password-input";
import "../forms/form.css";
//import CustomStepper from "../../ui-component/CustomStepper";
import AutoHideAlert from "../../ui-component/AutoHideAlert";
import DisplayTable from "../../ui-component/DisplayTable";
import MapComponent from "views/direct/LiveMap";
import { useLocation } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import VehiclesServices from "../../services/VehicleService";

// const steps = [
//   { label: "tagDeviceForm.steps.tagDevice", name: "Step 1" },
//   { label: "tagDeviceForm.steps.dealerVerification", name: "Step 2" },
//   { label: "tagDeviceForm.steps.sendOwnerOtp", name: "Step 3" },
//   { label: "tagDeviceForm.steps.ownerVerification", name: "Step 4" },
//   { label: "tagDeviceForm.steps.readyForActivation", name: "Step 5" },
//   { label: "tagDeviceForm.steps.getLocation", name: "Step 6" },
//   { label: "tagDeviceForm.steps.otCommandConfiguration", name: "Step 7" },
//   { label: "tagDeviceForm.steps.confirmLocation", name: "Step 8" },
//   { label: "tagDeviceForm.steps.sosButtonPress", name: "Step 9" },
//   { label: "tagDeviceForm.steps.activateSosInApp", name: "Step 10" },
//   { label: "tagDeviceForm.steps.ownerOtpConfirmation", name: "Step 11" },
// ];

const rawOtCommands = [
  "@SETPIP-135.235.166.209*",
  "@SETPPORT-6000*",
  "@SETEIP-135.235.166.209*",
  "@SETEPORT-5001*",
  "@SETESCN-9101109854*",
  "@SETAPN-airtelgprs.com*",
];

const formattedOtCommands = rawOtCommands.map((command) =>
  command.replace(/^@SET/i, "")
);

function TagDeviceToVehicle() {
  const { t } = useTranslation();
  const location = useLocation();
  const [updatedFormFields, setUpdatedFormField] = useState(taggingFields);
  const [deviceId, setDeviceId] = useState("");
  // const [activeStep, setActiveStep] = useState(0);
  const [deviceSosAlertReceived, setDeviceSosAlertReceived] = useState(false);
  const [appSosAlertReceived, setAppSosAlertReceived] = useState(false);
  //const [htmlContent, setHtmlContent] = useState("");
  const [mapLoaded, setMapLoaded] = useState(false);
  const [reload, setReload] = useState(false);
  const [getMap, setGetMap] = useState({ imei: "", regno: "" });
  const deviceSosEnteredAtRef = useRef(null);
  const appSosEnteredAtRef = useRef(null);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [vehicleMakeList, setVehicleMakeList] = useState([]);
  const [vehicleModelList, setVehicleModelList] = useState([]);
  const [loading, setLoading] = useState({
    loader: false,
    form: false,
  });
  const [error, setError] = useState({
    normal: false,
    api: false,
  });
  const [dealerDistricts, setDealerDistricts] = useState([]);
  const [imeiLocked, setImeiLocked] = useState(false);
  const [ownerMobileVerified, setOwnerMobileVerified] = useState(false);
  const [vehicleNumberLocked, setVehicleNumberLocked] = useState(false);
  const [vehicleNumberConfirmed, setVehicleNumberConfirmed] = useState(false);
  const [liveTrackingStatus, setLiveTrackingStatus] = useState({ confirmed: false, message: "", details: null });
  const [sosStatus, setSosStatus] = useState({ startSent: false, startConfirmed: false, stopSent: false, stopConfirmed: false, message: "" });
  const [checkingLiveTracking, setCheckingLiveTracking] = useState(false);
  const [packetStatusChecked, setPacketStatusChecked] = useState(false);
  const [processingSOS, setProcessingSOS] = useState(false);
  const vehicleNumberValidationTimerRef = useRef(null);

  // const getStepFromQuery = () => {
  //   try {
  //     const stepParam = new URLSearchParams(location.search).get("step");
  //     const stepNumber = stepParam === null ? null : Number(stepParam);
  //     if (!Number.isInteger(stepNumber)) return null;
  //     if (stepNumber < 0 || stepNumber > steps.length - 1) return null;
  //     return stepNumber;
  //   } catch (e) {
  //     return null;
  //   }
  // };

  const fetchEligibleImeis = async (oldVehicle) => {
    try {
      const response = await TaggingService.getEligibleImeiList({ old_vehicle: oldVehicle,stock_status: "Available_for_fitting", });
      const options = Array.isArray(response?.data?.data)
        ? response.data.data.map((device) => ({ value: device.id, label: device.imei }))
        : [];
      setUpdatedFormField((prev) => ({
        ...prev,
        device: {
          ...prev.device,
          options,
        },
      }));
    } catch (error) {
      console.error("Failed to load eligible IMEI list", error?.response?.data || error?.message);
    }
  };

  useEffect(() => {
    return () => {
      if (vehicleNumberValidationTimerRef.current) {
        window.clearTimeout(vehicleNumberValidationTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const loadStates = async () => {
      try {
        const stateList = await retriveStateList();
        setUpdatedFormField((prev) => ({
          ...prev,
          state_code: {
            ...prev.state_code,
            options: stateList,
          },
        }));
      } catch (err) {
        console.error(err);
      }
    };

    loadStates();
    fetchEligibleImeis(true);
  }, []);

  const handleVehicleTypeChange = async (event, formik) => {
    const value = event.target.value;
    formik.setFieldValue("vehicle_type", value);
    if (!imeiLocked) {
      await fetchEligibleImeis(value === "old");
    }
    if (value === "new") {
      formik.setFieldValue("vehicle_number", "");
      const chassisValue = formik.values?.chassis_no ?? "";
      const lastFour = chassisValue.slice(-4);
      formik.setFieldValue("owner_id", `TMP${lastFour}`);
    } else {
      formik.setFieldValue("owner_id", "");
    }
  };

  const handleDeviceSelection = async (event, formik) => {
  const deviceIdValue = event.target.value;

  formik.setFieldValue("device", deviceIdValue);

  if (deviceIdValue) {
    setImeiLocked(true);
  }
};

  const verifyOwnerMobile = async (event, formik) => {
    const mobile = event.target.value;
    if (ownerMobileVerified || mobile.length !== 10) return;
    try {
      const response = await TaggingService.verifyVehicleOwnerMobile({ mobile });
      const name = response?.data?.name || "";
      setOwnerMobileVerified(true);
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: `Owner mobile verified: ${name}`,
        type: "success",
      }));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to verify owner mobile.";
      formik.setFieldError("vehicle_owner", errorMessage);
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    }
  };

  const triggerVehicleNumberValidation = async (formik, value, overrideDeviceId) => {
    const normalizedValue = value?.trim()?.toUpperCase();
    const deviceId = overrideDeviceId || formik.values.device;

    if (!normalizedValue || vehicleNumberConfirmed || !deviceId) return;

    const isIndianRegistrationFormat = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/.test(normalizedValue);
    if (!isIndianRegistrationFormat) return;

    try {
      const response = await TaggingService.confirmRegNoCommand({
        device_id: deviceId,
        reg_no: normalizedValue,
      });

      if (response?.data) {
        setVehicleNumberLocked(true);
        setVehicleNumberConfirmed(true);
        formik.setFieldTouched("vehicle_number", true, false);
        setDismissibleAlert((prev) => ({
          ...prev,
          isOpen: true,
          message: "Vehicle registration validated successfully.",
          type: "success",
        }));
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        error?.message ||
        "Unable to validate registration number.";

      formik.setFieldError("vehicle_number", errorMessage);
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    }
  };

  const handleVehicleNumberSearch = async (formik) => {
  const value = formik.values.vehicle_number?.trim()?.toUpperCase();

  if (!value) {
    formik.setFieldError(
      "vehicle_number",
      "Please enter vehicle number."
    );
    return;
  }

  if (vehicleNumberLocked || vehicleNumberConfirmed) {
    return;
  }

  if (!formik.values.device) {
    formik.setFieldError(
      "vehicle_number",
      "Please select an IMEI first."
    );
    return;
  }

  const isIndianRegistrationFormat =
    /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/.test(value);

  if (!isIndianRegistrationFormat) {
    formik.setFieldError(
      "vehicle_number",
      "Enter a valid Indian Vehicle Registration Number (Example: BR01AB1234)"
    );
    return;
  }

  await triggerVehicleNumberValidation(
    formik,
    value,
    formik.values.device
  );
};

 const handleVehicleNumberChange = (event, formik) => {
  const nextValue = event?.target?.value?.toUpperCase() || "";

  formik.setFieldValue("vehicle_number", nextValue);

  // Only clear old timer.
  // Do NOT call API automatically while typing.
  if (vehicleNumberValidationTimerRef.current) {
    window.clearTimeout(vehicleNumberValidationTimerRef.current);
  }
};

  const handleVehicleNumberBlur = async (event, formik, overrideDeviceId) => {
    if (vehicleNumberValidationTimerRef.current) {
      window.clearTimeout(vehicleNumberValidationTimerRef.current);
    }

    await triggerVehicleNumberValidation(formik, event?.target?.value, overrideDeviceId);
  };

  const handleCheckLiveTracking = async (formik) => {
    if (!formik.values.device) {
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Select an IMEI before checking live tracking.",
        type: "error",
      }));
      return;
    }
    setCheckingLiveTracking(true);
    try {
      const response = await TaggingService.checkLiveTracking({ device_id: formik.values.device });
      setPacketStatusChecked(true);
      const confirmed = response?.data?.confirmed;
      setLiveTrackingStatus({
        confirmed: Boolean(confirmed),
        message: confirmed
          ? `Live location confirmed at ${response.data?.entry_time || "unknown time"}`
          : response?.data?.message || "No recent valid tracking packet found.",
        details: response?.data || null,
      });
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: confirmed
          ? "Live tracking confirmed."
          : response?.data?.message || "No recent valid tracking packet found.",
        type: confirmed ? "success" : "warning",
      }));
    } catch (error) {
      setPacketStatusChecked(true);
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to check live tracking.";
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    } finally {
      setCheckingLiveTracking(false);
    }
  };

  const handleSendSOSStart = async (formik) => {
    if (!formik.values.device) {
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Select an IMEI before sending SOS start command.",
        type: "error",
      }));
      return;
    }
    setProcessingSOS(true);
    try {
      await TaggingService.sendSOSStartCommand({ device_id: formik.values.device });
      setSosStatus((prev) => ({ ...prev, startSent: true, message: "SOS start command dispatched." }));
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "SOS start command dispatched.",
        type: "success",
      }));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to send SOS start command.";
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    } finally {
      setProcessingSOS(false);
    }
  };

  const handleConfirmSOSStart = async (formik) => {
    if (!formik.values.device) {
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Select an IMEI before confirming SOS start.",
        type: "error",
      }));
      return;
    }
    setProcessingSOS(true);
    try {
      const response = await TaggingService.confirmSOSStart({ device_id: formik.values.device });
      if (response?.data?.confirmed) {
        setSosStatus((prev) => ({ ...prev, startConfirmed: true, message: "SOS start confirmed." }));
        setDismissibleAlert((prev) => ({
          ...prev,
          isOpen: true,
          message: "SOS start confirmed.",
          type: "success",
        }));
      } else {
        setDismissibleAlert((prev) => ({
          ...prev,
          isOpen: true,
          message: response?.data?.message || "No SOS start packet received yet.",
          type: "warning",
        }));
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to confirm SOS start.";
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    } finally {
      setProcessingSOS(false);
    }
  };

  const handleSendSOSStop = async (formik) => {
    if (!formik.values.device) {
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Select an IMEI before sending SOS stop command.",
        type: "error",
      }));
      return;
    }
    setProcessingSOS(true);
    try {
      await TaggingService.sendSOSStopCommand({ device_id: formik.values.device });
      setSosStatus((prev) => ({ ...prev, stopSent: true, message: "SOS stop command dispatched." }));
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "SOS stop command dispatched.",
        type: "success",
      }));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to send SOS stop command.";
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    } finally {
      setProcessingSOS(false);
    }
  };

  const handleConfirmSOSStop = async (formik) => {
    if (!formik.values.device) {
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Select an IMEI before confirming SOS stop.",
        type: "error",
      }));
      return;
    }
    setProcessingSOS(true);
    try {
      const response = await TaggingService.confirmSOSStop({ device_id: formik.values.device });
      if (response?.data?.confirmed) {
        setSosStatus((prev) => ({ ...prev, stopConfirmed: true, message: "SOS stop confirmed." }));
        setDismissibleAlert((prev) => ({
          ...prev,
          isOpen: true,
          message: "SOS stop confirmed.",
          type: "success",
        }));
      } else {
        setDismissibleAlert((prev) => ({
          ...prev,
          isOpen: true,
          message: response?.data?.message || "No SOS stop packet received yet.",
          type: "warning",
        }));
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        "Unable to confirm SOS stop.";
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: errorMessage,
        type: "error",
      }));
    } finally {
      setProcessingSOS(false);
    }
  };

  const handleStateChange = async (event, formik) => {
    const stateId = event.target.value;

    formik.setFieldValue("state_code", stateId);
    formik.setFieldValue("district_code", "");

    try {
      const districts = await retriveDistrictList({
        state: stateId,
      });
      setDistrictOptions(districts || []);

      setUpdatedFormField((prev) => ({
        ...prev,
        district_code: {
          ...prev.district_code,
          options: districts || [],
          disabled: false,
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleDistrictChange = (event, formik) => {
    const districtId = event.target.value;

    formik.setFieldValue("district_code", districtId);
  };

  // useEffect(() => {
  //   const dealerDistricts = localStorage.getItem('dealerDistricts');
  //   if (dealerDistricts) {
  //     const districts = JSON.parse(dealerDistricts);
  //     const mappedDistricts = districts.map(district => ({
  //       label: district.district,
  //       value: district.id
  //     }));
  //     const mappedDistrictCode = districts.map(district => {
  //       const fullCode = district.district_code || "";
  //       const stateMatch = fullCode.match(/^[A-Za-z]+/);
  //       const numericPart = stateMatch ? fullCode.slice(stateMatch[0].length).trim() : fullCode;
  //       return {
  //         label: numericPart, // e.g. "01 02" shown in dropdown
  //         value: fullCode,    // e.g. "AS01 02" kept as actual value
  //       };
  //     });
  //     setDealerDistricts(mappedDistricts);

  //     // Update the form fields with the mapped districts
  //     setUpdatedFormField(prevConfig => ({
  //       ...prevConfig,
  //       district: {
  //         ...prevConfig.district,
  //         options: mappedDistricts
  //       },
  //       district_code: {
  //         ...prevConfig.district_code,
  //         options: mappedDistrictCode
  //       }
  //     }));
  //   }
  // }, []);

  // const [otp, setOtp] = useState({
  //   dealer: "",
  //   owner: "",
  //   finalOwner: "",
  // });
  const [dismissibleAlert, setDismissibleAlert] = useState({
    isOpen: false,
    type: "success",
    message: "",
  });


  const [ownerDetails, setOwnerDetails] = useState({
    name: "",
    email: "",
    mobile: "",
    device_ESN: "",
    ICCID: "",
    ICCID2: "",
    IMEI: "",
    vehicle_reg_no: "",
    vehicle_make: "",
    vehicle_model: "",
    engine_no: "",
    chassis_no: "",
    category: "",
    telecom_provider_1: "",
    telecom_provider_2: "",
    MSSISDN_1: "",
    MSSISDN_2: "",
    esim_validity: "",
    esim_provider: "",
    model: "",

  });

  const [vahanDetails, setVahanDetails] = useState({
    owner_name: "",
    email: "",
    mobile: "",
    device_serial_no: "",
    ICCID: "",
    IMEI: "",
    vehicle_reg_no: "",
    vehicle_make: "",
    vehicle_model: "",
    engine_no: "",
    chassis_no: "",
    vehicle_class: "",
    date_of_registration: "",
    device_activation_status: "",
    fitment_centre_name: "",
    GNSS_constellation_code: "",
    tac_no: "",
    tac_valid_upto: "",

  })

  const handleDistrictCodeChange = (event, formik) => {
    const value = event?.target?.value || "";
    const stateMatch = value.match(/^[A-Za-z]+/);
    const stateCode = stateMatch ? stateMatch[0] : "";
    formik.setFieldValue("state_code", stateCode);
  };

  useEffect(() => {
    (async () => {
      try {
        const categoryList = await fetchVehicleCategory();

        const safeCategoryList = Array.isArray(categoryList)
          ? categoryList
          : [];

        const makeResponse = await VehiclesServices.getVehicleMakeList();

        setVehicleMakeList(makeResponse.data);

        const makeOptions = makeResponse.data.map(item => ({
          label: item.make,
          value: item.make,
        }));

        setUpdatedFormField((prevConfig) => ({
          ...prevConfig,
          category: {
            ...prevConfig.category,
            options: safeCategoryList,
          },
          vehicle_make: {
            ...prevConfig.vehicle_make,
            options: makeOptions,
          },
        }));





        setLoading((prev) => ({
          ...prev,
          form: true,
        }));
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  // const handleVehicleMakeChange = (event, formik) => {
  //   const selectedMake = event.target.value;

  //   formik.setFieldValue("vehicle_make", selectedMake);
  //   formik.setFieldValue("vehicle_model", "");

  //   const selected = vehicleMakeList.find(
  //     item => item.make === selectedMake
  //   );

  //   const models = (selected?.models || []).map(item => ({
  //     label: item.model,
  //     value: item.model
  //   }));

  //   setUpdatedFormField(prev => ({
  //     ...prev,
  //     vehicle_model: {
  //       ...prev.vehicle_model,
  //       options: models,
  //       disabled: false
  //     }
  //   }));
  // };


  const handleVehicleMakeChange = (event, formik) => {
  const selectedMake = event.target.value;

  formik.setFieldValue("vehicle_make", selectedMake);

  // Clear previously entered model when make changes
  formik.setFieldValue("vehicle_model", "");
};

  // const handleVehicleModelChange = (event, formik) => {

  //   formik.setFieldValue(
  //     "vehicle_model",
  //     event.target.value
  //   );
  // };

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const deviceList = await fetchDeviceListForTagging();
  //       const categoryList = await fetchVehicleCategory();

  //       // Ensure deviceList and categoryList are arrays before updating
  //       const safeDeviceList = Array.isArray(deviceList) ? deviceList : [];
  //       const safeCategoryList = Array.isArray(categoryList) ? categoryList : [];

  //       setUpdatedFormField((prevConfig) => ({
  //         ...prevConfig,
  //         device: {
  //           ...prevConfig.device,
  //           options: safeDeviceList,
  //         },
  //         category: {
  //           ...prevConfig.category,
  //           options: safeCategoryList,
  //         },
  //       }));
  //       setLoading((prev) => ({ ...prev, form: true }));
  //     } catch (error) {
  //       console.error("Error fetching form data:", error);
  //       setDismissibleAlert((prev) => ({
  //         ...prev,
  //         isOpen: true,
  //         message: "Error loading form data. Please try again.",
  //         type: "error",
  //       }));
  //     }
  //   })();
  //   const stepFromQuery = getStepFromQuery();
  //   setActiveStep(stepFromQuery ?? 0);
  // }, [reload]);

  // useEffect(() => {
  //   const stepFromQuery = getStepFromQuery();
  //   if (stepFromQuery === null) return;
  //   setActiveStep(stepFromQuery);
  // }, [location.search]);

  // useEffect(() => {
  //   if (activeStep === 8) {
  //     if (!deviceSosEnteredAtRef.current) deviceSosEnteredAtRef.current = new Date();
  //   } else if (activeStep === 9) {
  //     if (!appSosEnteredAtRef.current) appSosEnteredAtRef.current = new Date();
  //   }
  // }, [activeStep]);

  // useEffect(() => {
  //   if (activeStep !== 8 && activeStep !== 9) return;

  //   const enteredAt = activeStep === 8 ? deviceSosEnteredAtRef.current : appSosEnteredAtRef.current;
  //   const alreadyReceived = activeStep === 8 ? deviceSosAlertReceived : appSosAlertReceived;
  //   if (alreadyReceived) return;
  //   if (!enteredAt) return;

  //   const baseUrl = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
  //   const emergencyLogUrl = baseUrl
  //     ? `${baseUrl}/api/gps-em-data-log-table/`
  //     : "/api/gps-em-data-log-table/";

  //   const poll = async () => {
  //     try {
  //       const searchValue = ownerDetails?.IMEI || getMap?.imei || "";
  //       const res = await axios.get(
  //         emergencyLogUrl,
  //         {
  //           params: { search: searchValue },
  //         }
  //       );
  //       const dataString = res?.data?.data;
  //       if (!dataString) return;
  //       const parsed = JSON.parse(dataString);
  //       const hasNew = Array.isArray(parsed)
  //         ? parsed.some((item) => {
  //           const ts = item?.fields?.timestamp;
  //           if (!ts) return false;
  //           const tms = new Date(ts).getTime();
  //           return Number.isFinite(tms) && tms > enteredAt.getTime();
  //         })
  //         : false;

  //       if (!hasNew) return;

  //       if (activeStep === 8) {
  //         setDeviceSosAlertReceived(true);
  //       } else if (activeStep === 9) {
  //         setAppSosAlertReceived(true);
  //       }
  //     } catch (e) {
  //       // ignore polling errors
  //     }
  //   };

  //   poll();
  //   const id = setInterval(poll, 5000);
  //   return () => clearInterval(id);
  // }, [activeStep, deviceSosAlertReceived, appSosAlertReceived, ownerDetails?.IMEI, getMap?.imei]);

  // const handleDealerOtp = (otp) => {
  //   setOtp((prev) => ({ ...prev, dealer: otp }));
  // };
  // const handleOwnerOtp = (otp) => {
  //   setOtp((prev) => ({ ...prev, owner: otp }));
  // };
  // const handleFinalOwnerOtp = (otp) => {
  //   setOtp((prev) => ({ ...prev, finalOwner: otp }));
  // };
  // const handleOtpSubmit = async (type) => {
  //   setLoading((prev) => ({ ...prev, loader: true }));
  //   const OtpData = {
  //     otp: otp?.[type],
  //     device_id: deviceId,
  //   };
  //   try {
  //     if (type === 'dealer') { await TaggingService.tagVerifyDealerOtp(OtpData); }
  //     if (type === 'owner') { await TaggingService.tagVerifyOwnerOtp(OtpData); }
  //     if (type === 'finalOwner') { await TaggingService.verifyTagVerifyOwnerOtpFinal(OtpData); }
  //     setActiveStep(prevActiveStep => prevActiveStep + 1)
  //     setDismissibleAlert(prev => ({ ...prev, isOpen: true, message: 'OTP has been successfully verified', type: 'success' }));

  //   } catch (error) {
  //     setDismissibleAlert((prev) => ({
  //       ...prev,
  //       isOpen: true,
  //       message:
  //         "Something went wrong! Please try after sometimes or check your details",
  //       type: "error",
  //     }));
  //   } finally {
  //     setLoading((prev) => ({ ...prev, loader: false }));
  //   }
  // };
  // const sendOwnerOtp = async (type) => {
  //   setLoading((prev) => ({ ...prev, loader: true }));
  //   const otpData = {
  //     device_id: deviceId,
  //   };
  //   try {
  //     if (type === 'owner') { await TaggingService.tagSendOwnerOtp(otpData); }
  //     if (type === 'finalOwner') { await TaggingService.sendTagSendOwnerOtpFinal(otpData); }
  //     setActiveStep(prevActiveStep => prevActiveStep + 1)
  //     setDismissibleAlert(prev => ({ ...prev, isOpen: true, message: 'Vehicle Owner OTP has been sent successfully', type: 'success' }));
  //   } catch (error) {
  //     console.error("Error while submitting data", error.message);
  //     setDismissibleAlert((prev) => ({
  //       ...prev,
  //       isOpen: true,
  //       message:
  //         "Something went wrong! Please try after sometimes or check your details",
  //       type: "error",
  //     }));
  //   } finally {
  //     setLoading((prev) => ({ ...prev, loader: false }));
  //   }
  // };
  // const getVahanDetail = async () => {
  //   setLoading((prev) => ({ ...prev, loader: true }));
  //   const deviceData = {
  //     device_id: deviceId,
  //   };
  //   try {
  //     const response = await TaggingService.vahanVerificationApi(deviceData);
  //     const device = response?.data?.Skytrack_data?.device || response?.Skytrack_data?.device;
  //     const owner = response?.data?.Skytrack_data?.vehicle_owner.users[0] || response?.Skytrack_data?.vehicle_owner.users[0];
  //     const vehicle = response?.data?.Skytrack_data || response?.Skytrack_data;
  //     const rawVahanData = response?.data?.vahan_data ?? response?.vahan_data;
  //     let vahanPayload = rawVahanData;
  //     if (rawVahanData && typeof rawVahanData === "string") {
  //       try {
  //         vahanPayload = JSON.parse(rawVahanData);
  //       } catch (e) {
  //         console.error("Failed to parse vahan_data string", e);
  //       }
  //     }
  //     const vahanData = vahanPayload?.VltdDetailsDobj || response?.data?.VltdDetailsDobj || response?.VltdDetailsDobj;
  //     setGetMap((prev) => ({
  //       ...prev,
  //       regno: vehicle.vehicle_reg_no,
  //       imei: device.imei,
  //     }));
  //     setOwnerDetails((prev) => ({
  //       ...prev,
  //       name: owner.name,
  //       email: owner.email,
  //       mobile: owner.mobile,
  //       device_ESN: device.device_esn,
  //       ICCID: device.iccid,
  //       ICCID2: device.iccid2,
  //       IMEI: device.imei,
  //       telecom_provider_1: device.telecom_provider1,
  //       telecom_provider_2: device.telecom_provider2,
  //       MSSISDN_1: device.msisdn1,
  //       MSSISDN_2: device.msisdn2,
  //       esim_validity: device.esim_validity,
  //       esim_provider: device.esim_provider[0],
  //       model: device.model,
  //       vehicle_reg_no: vehicle.vehicle_reg_no,
  //       engine_no: vehicle.engine_no,
  //       chassis_no: vehicle.chassis_no,
  //       vehicle_make: vehicle.vehicle_make,
  //       vehicle_model: vehicle.vehicle_model,
  //       category: vehicle.category,
  //     }));
  //     setVahanDetails((prev) => ({
  //       ...prev,
  //       chassis_no: vahanData?.chassisNo,
  //       date_of_registration: vahanData?.dateOfRegistration,
  //       device_activation_status: vahanData?.deviceActivationStatus,
  //       device_serial_no: vahanData?.deviceSerialno,
  //       engine_no: vahanData?.engineNo,
  //       fitment_centre_name: vahanData?.fitmentCentreName,
  //       GNSS_constellation_code: vahanData?.gnssConstellationCode,
  //       ICCID: vahanData?.iccId,
  //       IMEI: vahanData?.imeiNo,
  //       vehicle_make: vahanData?.makerName,
  //       vehicle_model: vahanData?.modelName,
  //       owner_name: vahanData?.ownerName,
  //       vehicle_reg_no: vahanData?.regnNo,
  //       tac_no: vahanData?.tacNo,
  //       tac_valid_upto: vahanData?.tacValidUpto,
  //       vehicle_class: vahanData?.vehClass,
  //     }));
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //     setDismissibleAlert(prev => ({ ...prev, isOpen: true, message: 'Vahan Details are successfully fetched', type: 'success' }));

  //   } catch (error) {
  //     console.error("Error :", error?.message);
  //     let errorString = "Something went wrong! Please try after sometimes or check your details";
  //     if (error?.response) {
  //       const errorObject = error?.response?.data || '';
  //       errorString = errorObject !== '' && Object.values(errorObject).flat().join(" ");
  //     }
  //     setDismissibleAlert((prev) => ({
  //       ...prev,
  //       isOpen: true,
  //       message: errorString,
  //       type: "error",
  //     }));
  //   } finally {
  //     setLoading((prev) => ({ ...prev, loader: false }));
  //   }
  // };
  // const retriveMapData = async () => {
  //   setLoading((prev) => ({ ...prev, loader: true }));
  //   try {
  //     const retriveData = await HomePageService.getLiveTracking_data(getMap);
  //     console.log("Retrieved Map Data:", retriveData.data);
  //     setHtmlContent(retriveData.data);
  //     setMapLoaded(true);

  //     setDismissibleAlert((prev) => ({
  //       ...prev,
  //       isOpen: true,
  //       message: "Map Details is fetched successfully",
  //       type: "success",
  //     }));
  //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
  //   } catch (error) {
  //     console.log("Error retrieving map data:", error);
  //     setDismissibleAlert((prev) => ({
  //       ...prev,
  //       isOpen: true,
  //       message:
  //         "Something went wrong! Please try after sometimes or check your details",
  //       type: "error",
  //     }));
  //   } finally {
  //     setLoading((prev) => ({ ...prev, loader: false }));
  //   }
  // };
  const handleFileChange = (event, formik) => {
    const selectedFile = event.target.files[0];
    const fieldName = event.target.name;
    if (selectedFile) {
      formik.setFieldValue(fieldName, selectedFile);
    }
  };

  const validationTagging = Yup.object(
    Object.keys(updatedFormFields).reduce((acc, field) => {
      acc[field] = updatedFormFields[field].validation;
      return acc;
    }, {})
  );

  const generateInvoice = (invoiceData) => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = 210;
    const pageHeight = 297;
    const dealer = invoiceData?.dealer || "";
    const customer = invoiceData?.customer || "";
    const customerGstin = invoiceData?.customer_gstin || "";
    const dealerGstn = invoiceData?.dealer_gstn || "";
    const dealerAddress = invoiceData?.dealer_address || "";
    const dealerState = invoiceData?.dealer_state || "";
    const ownerMobile = invoiceData?.owner_mobile_no || "";
    const vehicleRegNo = invoiceData?.vehicle_reg_no || "";
    const chassisNo = invoiceData?.chassis_no || "";
    const bankName =
      invoiceData?.bank_name ||
      process.env.REACT_APP_BANK_NAME ||
      "";

    const accountName =
      invoiceData?.account_name ||
      process.env.REACT_APP_ACCOUNT_NAME ||
      "";

    const accountNo =
      invoiceData?.account_number ||
      process.env.REACT_APP_ACCOUNT_NUMBER ||
      "";

    const ifscCode =
      invoiceData?.ifsc_code ||
      process.env.REACT_APP_IFSC_CODE ||
      "";

    const branch =
      invoiceData?.branch ||
      process.env.REACT_APP_BRANCH ||
      "";

    const today =
      invoiceData?.invoice_date || new Date().toLocaleDateString("en-GB");

    const taxable = Number(invoiceData?.net_amount || 0);
    const cgst = Number(invoiceData?.cgst_9_percent || 0);
    const sgst = Number(invoiceData?.sgst_9_percent || 0);
    const igst = Number(invoiceData?.igst_18_percent || 0);
    const total = Number(invoiceData?.gross_amount || 0);
    const vehicleMake = invoiceData?.vehicle_make || "";
    const vehicleModel = invoiceData?.vehicle_model || "";
    const imeiNo = invoiceData?.device_imei_no || "";
    const customerAddress = invoiceData?.customer_address || "";

    const ownerState = invoiceData?.owner_state || "";

    const dealerStateId = Number(invoiceData?.dealer_state_id);
    const ownerStateId = Number(invoiceData?.owner_state_id);

    // Dealer State != Owner State => IGST
    const isIGST = dealerStateId !== ownerStateId;
    // ===============================
    // HELPERS
    // ===============================
    const txt = (t, x, y, size = 10, style = "normal", color = [0, 0, 0]) => {
      doc.setFont("times", style);
      doc.setFontSize(size);
      doc.setTextColor(...color);
      doc.text(String(t), x, y);
    };


    const line = (x1, y1, x2, y2) => doc.line(x1, y1, x2, y2);


    // ===============================
    // TITLE
    // ===============================
    doc.rect(5, 5, 200, 13);

    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("Tax Invoice", 105, 13, { align: "center" });


    // TOP BOX
    doc.rect(5, 18, 200, 95);

    // 50% | 25% | 25%
    const leftCol = 105; // 5 + 100
    const midCol = 155;  // 105 + 50

    line(leftCol, 18, leftCol, 113);
    line(midCol, 18, midCol, 113);

    // Horizontal lines for center + right sections
    line(leftCol, 38, 205, 38);
    line(leftCol, 58, 205, 58);
    line(leftCol, 78, 205, 78);

    // LEFT SELLER
    txt("Seller", 7, 24, 14);

    txt(dealer, 7, 31, 12, "bold");
    txt(`Address: ${dealerAddress}`, 7, 38, 12);
    txt(`GSTIN: ${dealerGstn}`, 7, 45, 12);
    txt(`State : ${dealerState}`, 7, 52, 12);

    // Seller / Buyer Divider
    line(5, 63, 105, 63);

    txt("Buyer", 7, 72, 14);

    txt(customer, 7, 80, 12, "bold");
    txt(`Address: ${customerAddress}`, 7, 88, 12);
    txt(`State :${ownerState}`, 7, 96, 12);
    txt(`GSTIN : ${customerGstin}`, 7, 104, 12);
    txt(`Mobile No: ${ownerMobile}`, 7, 112, 12);
    // CENTER COLUMN
    txt("Invoice No.", 110, 25, 14, "bold");
    const invoiceNo = invoiceData?.bill_no || "";
    txt(invoiceNo, 110, 33, 12);

    txt("Supplier Reference", 110, 45, 14, "bold");
    txt(invoiceData?.device_imei_no || "", 110, 53, 12);

    txt("Registration No", 110, 65, 14, "bold");
    txt(vehicleRegNo, 110, 73, 12);

    txt("Date", 160, 25, 14, "bold");
    txt(today, 160, 33, 12);

    txt("Chassis No", 160, 45, 14, "bold");
    txt(chassisNo, 160, 53, 12);

    txt("Quantity", 160, 65, 14, "bold");
    txt("1 Pcs", 160, 73, 12);

    // ===============================
    // PRODUCT TABLE
    // ===============================

    doc.rect(5, 113, 200, 84);

    const cols = [
      5,    // SL
      18,   // Description
      98,   // HSN
      116,  // GST
      128,  // Qty (reduced)
      148, // Rate start
      174, // Per start
      184, // Amount start
      205
    ];

    cols.forEach((x) => line(x, 113, x, 197));

    // horizontal lines
    line(5, 123, 205, 123); // header

    line(5, 165, 205, 165); // item section
    line(5, 173, 205, 173); // discount
    // line(5, 181, 205, 181); // cgst
    // line(5, 189, 205, 189); // sgst
    // line(5, 197, 205, 197); // igst
    if (isIGST) {
      line(5, 197, 205, 197); // igst
    } else {
      line(5, 181, 205, 181); // cgst
      line(5, 189, 205, 189); // sgst
    }
    // Headers
    txt("SL", 9, 120, 11);
    txt("Description of Goods", 22, 120, 11);

    txt("HSN", 102, 120, 11);
    txt("GST", 120, 120, 11);
    txt("Qty", 132, 120, 11);
    txt("Rate", 154, 120, 11);
    txt("Per", 176, 120, 11);
    txt("Amount", 190, 120, 11);

    // Product row
    txt("1", 9, 136, 12);

    txt("Vehicle Location Tracking Device", 22, 136, 12, "bold");

    txt("Make : Mapwala", 22, 145, 12);
    txt("Model : Mapwala T600", 22, 153, 12);

    txt(`IMEI : ${imeiNo}`, 22, 161, 11, "bold");
    txt("852691", 102, 144, 12);
    txt("18%", 120, 144, 12);
    txt("1 Pcs", 131, 144, 12);

    doc.setFont("times", "bold");
    doc.setFontSize(11);

    // Rate column (152-170)
    doc.text(
      taxable.toFixed(2),
      168,
      144,
      { align: "right" }
    );

    // Per column (170-182)
    doc.setFont("times", "normal");
    doc.setFontSize(10);

    doc.text(
      "Pcs",
      179,
      144,
      { align: "center" }
    );

    // Amount column (182-205)
    doc.setFont("times", "bold");
    doc.text(
      taxable.toFixed(2),
      203,
      144,
      { align: "right" }
    );

    // Discount Row
    txt("Discount", 22, 169, 12);
    if (isIGST) {
      txt("IGST", 102, 194, 12);
      txt("18%", 120, 194, 12);
      txt(igst.toFixed(2), 187, 194, 12, "bold");

    } else {
      txt("CGST", 102, 178, 12);
      txt("9%", 120, 178, 12);
      txt(cgst.toFixed(2), 187, 178, 12, "bold");

      txt("SGST", 102, 186, 12);
      txt("9%", 120, 186, 12);
      txt(sgst.toFixed(2), 187, 186, 12, "bold");


    }
    // TOTAL ROW
    // TOTAL ROW
    doc.rect(5, 197, 200, 10);

    // Qty column
    line(128, 197, 128, 207);

    // Amount column (same as table above)
    line(184, 197, 184, 207);

    txt("Total", 22, 204, 11, "bold");
    txt("1 Pcs", 132, 204, 12);

    doc.setFont("times", "bold");
    doc.text(
      total.toFixed(2),
      203,
      204,
      { align: "right" }
    );
    // ===============================
    // AMOUNT WORDS
    // ===============================
    const numberToWords = (num) => {
      const a = [
        "", "One", "Two", "Three", "Four", "Five",
        "Six", "Seven", "Eight", "Nine", "Ten",
        "Eleven", "Twelve", "Thirteen", "Fourteen",
        "Fifteen", "Sixteen", "Seventeen", "Eighteen",
        "Nineteen"
      ];

      const b = [
        "", "", "Twenty", "Thirty", "Forty",
        "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
      ];

      const inWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100)
          return b[Math.floor(n / 10)] + " " + a[n % 10];
        if (n < 1000)
          return (
            a[Math.floor(n / 100)] +
            " Hundred " +
            inWords(n % 100)
          );
        return (
          inWords(Math.floor(n / 1000)) +
          " Thousand " +
          inWords(n % 1000)
        );
      };

      return inWords(num);
    };
    // Amount words section (keep same height)
    doc.rect(5, 207, 200, 18);

    txt("Amount Chargeable (in words)", 7, 214, 12);

    txt(
      `${numberToWords(Math.round(total))} Only`,
      7,
      221,
      12,
      "bold"
    );

    // ===============================
    // BANK DETAILS
    // ===============================

    doc.rect(5, 225, 200, 30);

    txt("Seller Bank Details", 10, 233, 12, "bold");

    txt(`Name : ${accountName}`, 10, 240, 11);
    txt(`A/c No : ${accountNo}`, 10, 246, 11);
    txt(`Bank : ${bankName}`, 10, 251, 11);

    txt(`Branch : ${branch}`, 110, 240, 11);
    txt(`IFSC : ${ifscCode}`, 110, 246, 11);

    // ===============================
    // DECLARATION + AUTHORISED SIGN
    // ===============================

    doc.rect(5, 255, 200, 20);
    line(140, 255, 140, 275);

    txt("Declaration:", 8, 262, 12, "bold");

    txt(
      "We declare that this invoice shows the actual",
      8,
      267,
      11
    );

    txt(
      "price of the goods described and particulars are correct.",
      8,
      272,
      11
    );

    doc.setFont("times", "bold");
    doc.setFontSize(12);

    doc.text(
      "Authorised Signatory",
      172.5,
      270,
      { align: "center" }
    );

    // ===============================
    // COMPUTER GENERATED INVOICE
    // =================//


    // Center aligned text
    doc.setFont("times", "italic");
    doc.setFontSize(12);

    doc.text(
      "This is a Computer Generated Invoice",
      pageWidth / 2,
      287,
      { align: "center" }
    );
    // ===============================
    // OPEN + DOWNLOAD
    // ===============================
    window.open(doc.output("bloburl"), "_blank");
    doc.save(`Invoice_${vehicleRegNo || "invoice"}.pdf`);
  };

  const handleTagging = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setLoading((prev) => ({ ...prev, loader: true }));
    try {
      const isNewVehicle = values?.vehicle_type === "new";
      // const selectedDistrict = districtOptions.find(
      //   (item) => Number(item.value) === Number(values.district_code)
      // );

      // const districtCode = (
      //   selectedDistrict?.district_code || ""
      // ).toUpperCase();

      // let suffix = isNewVehicle
      //   ? (values.owner_id || "")
      //   : (values.vehicle_number || "");

      // suffix = suffix.toUpperCase().trim();
      // while (suffix.startsWith(districtCode)) {
      //   suffix = suffix.substring(districtCode.length);
      // }
      // // Remove existing prefix if user already typed it
      // const prefixRegex = new RegExp(
      //   `^${districtCode}`,
      //   "i"
      // );

      // suffix = suffix.replace(prefixRegex, "");

      // const vehicleRegNo = `${districtCode}${suffix}`;

      const chassisNo = (values?.chassis_no || "").trim().toUpperCase();

const lastFour = chassisNo.slice(-4);

const temporaryVehicleRegNo = `TMP${lastFour}`;

const apiValues = {
  ...values,

  temp_reg: isNewVehicle,

  vehicle_reg_no: isNewVehicle
    ? temporaryVehicleRegNo
    : values.vehicle_number,

  device_registration_date: values.device_registration_date,
};

delete apiValues.vehicle_type;
delete apiValues.vehicle_number;
      const response =
        await TaggingService.tagDeviceToVehicleComplete(apiValues);

      const deviceId = response?.data?.data?.device;

      // const invoiceResponse =
      //   await TaggingService.getDeviceTagInvoice({
      //     q: response?.data?.data?.deviceId, // use tagId
      //   });
      // const invoiceData =
      //   invoiceResponse?.data?.results?.results?.[0] || {};
      resetForm(taggingInitials);

      setDeviceId(deviceId);

      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: "Device tagging successfully.Technician will Do Installation.",
        type: "success",
      }));

      // generateInvoice(invoiceData);
    } catch (error) {
      console.log(error);
      const errorData = error?.response?.data?.detail || error?.response?.data?.error
      const message = errorData ? "Error Details " + errorData : 'Something went wrong! Please try after sometimes or check your details';
      if (error?.message === "Network Error") {
        setError((prev) => ({ ...prev, api: true }));
      } else {

        setError((prev) => ({ ...prev, normal: true }));
      }
      setDismissibleAlert((prev) => ({
        ...prev,
        isOpen: true,
        message: message,
        type: "error",
      }));
    } finally {
      setLoading((prev) => ({ ...prev, loader: false }));
      setSubmitting(false);
    }
  };
  const handleDismissibleAlert = () => {
    setDismissibleAlert((prev) => ({ ...prev, isOpen: false, message: "" }));
  };
  // const reset = () => {
  //   setReload((prev) => !prev);
  // };
  return (
    <>
      <AutoHideAlert
        open={dismissibleAlert.isOpen}
        onClose={handleDismissibleAlert}
        message={dismissibleAlert.message}
        type={dismissibleAlert.type}
      />
      {error.api && (
        <Alert severity="error" style={{ marginBottom: "16px" }}>
          <AlertTitle>{t("common.error")}</AlertTitle>
          {t("common.internalServerError")}
        </Alert>
      )}
      <Grid container spacing={gridSpacing}>
        {loading.loader && (
          <div className="spinner-div">
            <CircularProgress className="circular-progress" size={50} />
          </div>
        )}
        {/* <Grid item xs={12} style={{ width: "100%" }}>
          <CustomStepper activeStep={activeStep} label={false} steps={steps.map(step => ({ ...step, label: t(step.label) }))} />
        </Grid> */}
        <Grid
          item
          xs={12}
          className={loading.loader ? "loading" : "not-loading"}
        >
          <MainCard>
            {/* {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 1 }}>
                  {t("tagDeviceForm.messages.allStepsCompleted")}
                </Typography>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={reset}
                >
                  {t("common.finish")}
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography sx={{ mt: 2, mb: 2 }} variant="h4">
                  {t(steps[activeStep].label)}
                </Typography>
              </React.Fragment>
            )} */}

            {/* {activeStep === 0 && loading.form && (
              <Formik
                initialValues={taggingInitials}
                validationSchema={validationTagging}
                onSubmit={handleTagging}
                enableReinitialize
              >
                {(formik) => (
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="form-controller">
                      {Object.keys(updatedFormFields).map((field, idx, arr) => {
                        const isNewVehicle = formik?.values?.vehicle_type === "new";
                        if (field === "vehicle_reg_no") return null; // skip old field
                        if (field === "state_code") return null; // rendered inside vehicle_reg_group
                        // Custom rendering for state_code + district_code + vehicle_number as one row
                        if (field === "district_code") {
                          return (
                            <Grid key="vehicle_reg_group" item lg={4} md={4} sm={6} xs={12}>
                              <Grid container spacing={1} alignItems="flex-end">
                                <Grid item xs={3}>
                                  <FormField
                                    fieldConfig={updatedFormFields["state_code"]}
                                    formik={formik}
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <FormField
                                    fieldConfig={updatedFormFields["district_code"]}
                                    formik={formik}
                                    handleOptionChange={handleDistrictCodeChange}
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  {isNewVehicle ? (
                                    <FormField
                                      fieldConfig={updatedFormFields["owner_id"]}
                                      formik={formik}
                                    />
                                  ) : (
                                    <FormField
                                      fieldConfig={updatedFormFields["vehicle_number"]}
                                      formik={formik}
                                      onChange={(e) => {
                                        let value = e.target.value.toUpperCase();
                                        formik.setFieldValue("vehicle_number", value);
                                      }}
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        }
                        // Skip vehicle_number, since it's rendered above
                        if (field === "vehicle_number") return null;

                        if (field === "owner_id") return null;

                        return (
                          <Grid key={field} item lg={4} md={4} sm={6} xs={12}>
                            <div style={{ width: "100%" }}>

                              <Typography
                                sx={{
                                  mb: 1,
                                  fontSize: "15px",
                                  fontWeight: 700,
                                  color: "#16325c"
                                }}
                              >
                                {updatedFormFields[field]?.label}
                              </Typography>

                              <div
                                style={{
                                  background: "#f8fafc",
                                  borderRadius: "14px",
                                  padding: "2px"
                                }}
                              > <FormField
                                  fieldConfig={updatedFormFields[field]}
                                  formik={formik}
                                  handleFileChange={handleFileChange}
                                  onChange={
                                    field === "chassis_no"
                                      ? (e) => {
                                        const value = e?.target?.value ?? "";
                                        if (formik?.values?.vehicle_type === "new") {
                                          formik.setFieldValue("owner_id", `TMP${value}`);
                                        }
                                      }
                                      : undefined
                                  }
                                  handleOptionChange={
                                    field === "vehicle_type"
                                      ? (e) => {
                                        const value = e?.target?.value;
                                        formik.setFieldValue("vehicle_type", value);
                                        if (value === "new") {
                                          formik.setFieldValue("vehicle_number", "");
                                          const chassisValue = formik?.values?.chassis_no ?? "";
                                          formik.setFieldValue("owner_id", `TMP${chassisValue}`);
                                        } else {
                                          formik.setFieldValue("owner_id", "");
                                        }
                                      }
                                      : undefined
                                  }
                                /> </div></div>

                          </Grid>
                        );
                      })}
                      <Grid item xs={12} className="grid-item-button-div">
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={loading.loader}
                        >
                          Next
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            )} */}
            {loading.form && (
              <Formik
                initialValues={taggingInitials}
                validationSchema={validationTagging}
                onSubmit={handleTagging}
                enableReinitialize
              >
                {(formik) => (
                  <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2} className="form-controller">
                      {Object.keys(updatedFormFields).map((field, idx, arr) => {
                        const isNewVehicle = formik?.values?.vehicle_type === "new";
                        if (field === "vehicle_reg_no") return null; // skip old field
                        if (field === "state_code") return null; // rendered inside vehicle_reg_group
                        // Custom rendering for state_code + district_code + vehicle_number as one row
                        if (field === "district_code") {
                          return (
                            <Grid key="vehicle_reg_group" item lg={4} md={4} sm={6} xs={12}>
                              <Grid container spacing={1} alignItems="flex-end">
                                <Grid item xs={3}>
                                  <FormField
                                    fieldConfig={updatedFormFields["state_code"]}
                                    formik={formik}
                                    handleOptionChange={(e) => handleStateChange(e, formik)}

                                  />
                                </Grid>
                                <Grid item xs={3}>
                                  <FormField
                                    fieldConfig={updatedFormFields["district_code"]}
                                    formik={formik}
                                    handleOptionChange={(e) => handleDistrictChange(e, formik)}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  {isNewVehicle ? (
                                    <FormField
fieldConfig={{
      ...updatedFormFields["owner_id"],
      disabled: false,
    }}
                                          formik={formik}
                                    />
                                  ) : (
                                    <FormField
                                      fieldConfig={{
                                        ...updatedFormFields["vehicle_number"],
                                         disabled:
      !formik.values.device ||
      updatedFormFields["vehicle_number"].disabled ||
      vehicleNumberLocked,
  }}
                                      formik={formik}
                                      onChange={(e) => handleVehicleNumberChange(e, formik)}
                                      // onBlur={(e) => handleVehicleNumberBlur(e, formik)}
                                      endAdornment={
  <IconButton
    onClick={() => handleVehicleNumberSearch(formik)}
    disabled={
      !formik.values.device ||
      vehicleNumberLocked ||
      vehicleNumberConfirmed
    }
    edge="end"
    size="small"
  >
    <SearchIcon />
  </IconButton>
}
                                    />
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                          );
                        }
                        // Skip vehicle_number, since it's rendered above
                        if (field === "vehicle_number") return null;

                        if (field === "owner_id") return null;

                        return (
                          <Grid key={field} item lg={4} md={4} sm={6} xs={12}>
                            <div style={{ width: "100%" }}>

                              <Typography
                                sx={{
                                  mb: 1,
                                  fontSize: "15px",
                                  fontWeight: 700,
                                  color: "#16325c"
                                }}
                              >
                                {updatedFormFields[field]?.label}
                              </Typography>

                              <div
                                style={{
                                  background: "#f8fafc",
                                  borderRadius: "14px",
                                  padding: "2px"
                                }}
                              > <FormField
                                  fieldConfig={{
                                    ...updatedFormFields[field],
                                    disabled:
  (
    // NEW VEHICLE:
    // Until IMEI/device is selected, disable every field
    // except vehicle type and device.
    (
      isNewVehicle &&
      !formik.values.device &&
      field !== "vehicle_type" &&
      field !== "device"
    )
  ) ||
  (
    // OLD VEHICLE:
    // Until vehicle number is confirmed, keep the existing
    // old-vehicle fields disabled.
    !isNewVehicle &&
    !vehicleNumberConfirmed &&
    field !== "vehicle_type" &&
    field !== "device" &&
    field !== "vehicle_owner" &&
    field !== "vehicle_number"
  ) ||
  (field === "device" && imeiLocked) ||
  (field === "vehicle_owner" && ownerMobileVerified) ||
  (field === "vehicle_number" && vehicleNumberLocked) ||
  updatedFormFields[field]?.disabled,
}}
                                  formik={formik}
                                  handleFileChange={handleFileChange}
                                  onChange={
                                    field === "chassis_no"
                                      ? (e) => {
                                        const value = e?.target?.value ?? "";
                                        if (formik?.values?.vehicle_type === "new") {
                                          const lastFour = value.slice(-4);
                                          formik.setFieldValue("owner_id", `TMP${lastFour}`);
                                        }
                                      }
                                      : undefined
                                  }
                                  onBlur={
                                    field === "vehicle_owner"
                                      ? (e) => verifyOwnerMobile(e, formik)
                                      : field === "vehicle_number"
                                        ? (e) => handleVehicleNumberBlur(e, formik)
                                        : undefined
                                  }
                                   handleOptionChange={
                                    field === "vehicle_make"
                                      ? (e) => handleVehicleMakeChange(e, formik)
                                      : field === "vehicle_model"
                                          ? (e) => handleVehicleTypeChange(e, formik)
                                          : field === "device"
                                            ? (e) => handleDeviceSelection(e, formik)
                                            : undefined
                                  }
                                /> </div></div>

                          </Grid>
                        );
                      })}
                      <Grid item xs={12}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
                          <Button
                            type="button"
                            variant="contained"
                            color={liveTrackingStatus.confirmed ? "success" : "error"}
                            disabled={checkingLiveTracking || !formik.values.device}
                            onClick={() => handleCheckLiveTracking(formik)}
                          >
                            {liveTrackingStatus.confirmed ? "Live Packet OK" : "Check Live Packet"}
                          </Button>
                          <Button
  variant="outlined"
  color="primary"
  size="small"
  onClick={() => handleCheckLiveTracking(formik)}
  disabled={!packetStatusChecked || checkingLiveTracking}
>
  Refresh
</Button>
                          <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            disabled={processingSOS || !formik.values.device}
                            onClick={() => handleSendSOSStart(formik)}
                          >
                            Send SOS Start
                          </Button>
                          {/* <Button
                            type="button"
                            variant="contained"
                            color="info"
                            disabled={processingSOS || !sosStatus.startSent || !formik.values.device}
                            onClick={() => handleConfirmSOSStart(formik)}
                          >
                            Confirm SOS Start
                          </Button> */}
                          <Button
                            type="button"
                            variant="contained"
                            color="warning"
                            disabled={processingSOS || !formik.values.device}
                            onClick={() => handleSendSOSStop(formik)}
                          >
                            Send SOS Stop
                          </Button>
                          {/* <Button
                            type="button"
                            variant="contained"
                            color="secondary"
                            disabled={processingSOS || !sosStatus.stopSent || !formik.values.device}
                            onClick={() => handleConfirmSOSStop(formik)}
                          >
                            Confirm SOS Stop
                          </Button> */}
                        </div>
                        {(liveTrackingStatus.message || sosStatus.message) && (
                          <div style={{ marginTop: "12px", display: "flex", flexDirection: "column", gap: "6px" }}>
                            {liveTrackingStatus.message && (
                              <Typography variant="body2" sx={{ color: liveTrackingStatus.confirmed ? "green" : "red" }}>
                                {liveTrackingStatus.message}
                              </Typography>
                            )}
                            {sosStatus.message && (
                              <Typography
                                variant="body2"
                                sx={{ color: sosStatus.startConfirmed || sosStatus.stopConfirmed ? "green" : "orange" }}
                              >
                                {sosStatus.message}
                              </Typography>
                            )}
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={12} className="grid-item-button-div">
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={loading.loader}
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            )}
            {/* {activeStep === 1 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>
                    {t("tagDeviceForm.messages.dealerOtpSent")}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <MuiOtpInput
                    value={otp.dealer}
                    onChange={handleDealerOtp}
                    length={6}
                  />
                  <br />
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={() => handleOtpSubmit("dealer")}
                    >
                      {t("common.Confirm")}
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )}
            {activeStep === 2 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>{t("tagDeviceForm.messages.requestOwnerOtp")}</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={() => sendOwnerOtp("owner")}
                    >
                      {t("common.Request")}
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )}
            {activeStep === 3 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>
                    An OTP has been sent to vehicle owner mobile number. Please
                    enter the OTP below to continue.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <MuiOtpInput
                    value={otp.owner}
                    onChange={handleOwnerOtp}
                    length={6}
                  />
                  <br />
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={() => handleOtpSubmit("owner")}
                    >
                      Confirm
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )}
            {activeStep === 4 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>Click below to get details from Vahan</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <br />
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={getVahanDetail}
                    >
                      Get Details
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )}
            {activeStep === 5 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>
                    Click below to get location of Vehicle
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <br />
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={retriveMapData}
                    >
                      Get Location
                    </Button>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        borderRadius: '8px 0 0 8px',
                        border: '1px solid #f0f0f0',
                        backgroundColor: 'white'
                      }}
                    >
                      <DisplayTable
                        values={ownerDetails}
                        title="Details as in Skytron"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sx={{
                        borderRadius: '0 8px 8px 0',
                        border: '1px solid #f0f0f0',
                        backgroundColor: 'white'
                      }}
                    >
                      <DisplayTable
                        values={vahanDetails}
                        title="Details as in Vahan"
                      />
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>
            )}
            {activeStep === 6 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography sx={{ mb: 1 }}>
                    {t(
                      "tagDeviceForm.messages.executeOtCommands",
                      "Before proceeding, execute the following OT commands for the device."
                    )}
                  </Typography>
                  <Typography sx={{ mb: 2 }} variant="subtitle1">
                    {ownerDetails?.model
                      ? t(
                        "tagDeviceForm.messages.deviceModelOtCommands",
                        `Device model: ${ownerDetails.model}`
                      )
                      : t(
                        "tagDeviceForm.messages.deviceModelUnavailable",
                        "Device model information is unavailable."
                      )}
                  </Typography>
                  <ul style={{ paddingLeft: 24 }}>
                    {formattedOtCommands.map((command) => (
                      <li key={command}>
                        <Typography variant="body1" component="span">
                          {command}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography>
                    <Button
                      color="primary"
                      type="button"
                      variant="contained"
                      onClick={() => setActiveStep((prevActiveStep) => prevActiveStep + 1)}
                    >
                      {t("common.continue", "Continue")}
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )} */}
            {/* {activeStep === 7 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>{t("tagDeviceForm.messages.requestOwnerOtp")}</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={() => sendOwnerOtp("finalOwner")}
                    >
                      {t("common.request")}
                    </Button>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {mapLoaded && (
                    <MapComponent
                      gpsData={htmlContent?.data}
                      width="100%"
                      height="600px"
                    />
                  )}
                </Grid>
              </Grid>
            )}
            {activeStep === 8 && (
              <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
                <Grid item xs={12} sx={{ mb: 4, mt: 4 }}>
                  <Typography variant="body1" align="center" color="textSecondary">
                    {deviceSosAlertReceived
                      ? t("tagDeviceForm.messages.sosAlertReceived")
                      : t("tagDeviceForm.messages.sosButtonInstruction")}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      color: 'white',
                      backgroundColor: deviceSosAlertReceived ? '#4caf50' : '#f44336',
                      boxShadow: deviceSosAlertReceived
                        ? '0 8px 16px rgba(76,175,80,0.3)'
                        : '0 8px 16px rgba(244,67,54,0.3)',
                      '&:hover': {
                        backgroundColor: deviceSosAlertReceived ? '#388e3c' : '#d32f2f',
                        boxShadow: deviceSosAlertReceived
                          ? '0 10px 20px rgba(76,175,80,0.4)'
                          : '0 10px 20px rgba(244,67,54,0.4)',
                      }
                    }}
                    onClick={() => setActiveStep((prev) => prev + 1)}
                  >
                    SOS
                  </Button>
                </Grid>
                {deviceSosAlertReceived && (
                  <Grid item xs={12} sx={{ mt: 3 }} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      color="primary"
                      type="button"
                      variant="contained"
                      onClick={() => setActiveStep((prev) => prev + 1)}
                    >
                      {t("common.next", "Next")}
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
            {activeStep === 9 && (
              <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
                <Grid item xs={12} sx={{ mb: 4, mt: 4 }}>
                  <Typography variant="body1" align="center" color="textSecondary">
                    {appSosAlertReceived
                      ? t("tagDeviceForm.messages.sosAlertReceived")
                      : t("tagDeviceForm.messages.sosActivateInstruction")}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    sx={{
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      fontSize: '1.2rem',
                      fontWeight: 'bold',
                      color: 'white',
                      backgroundColor: appSosAlertReceived ? '#4caf50' : '#f44336',
                      boxShadow: appSosAlertReceived
                        ? '0 8px 16px rgba(76,175,80,0.3)'
                        : '0 8px 16px rgba(244,67,54,0.3)',
                      '&:hover': {
                        backgroundColor: appSosAlertReceived ? '#388e3c' : '#d32f2f',
                        boxShadow: appSosAlertReceived
                          ? '0 10px 20px rgba(76,175,80,0.4)'
                          : '0 10px 20px rgba(244,67,54,0.4)',
                      }
                    }}
                    onClick={() => setActiveStep((prev) => prev + 1)}
                  >
                    SOS
                  </Button>
                </Grid>
                {appSosAlertReceived && (
                  <Grid item xs={12} sx={{ mt: 3 }} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      color="primary"
                      type="button"
                      variant="contained"
                      onClick={() => setActiveStep((prev) => prev + 1)}
                    >
                      {t("common.next", "Next")}
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
            {activeStep === 10 && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography>
                    An OTP has been sent to vehicle owner mobile number. Please
                    enter the OTP below to continue.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <MuiOtpInput
                    value={otp.finalOwner}
                    onChange={handleFinalOwnerOtp}
                    length={6}
                  />
                  <br />
                  <Typography>
                    <Button
                      color="primary"
                      type="submit"
                      variant="contained"
                      onClick={() => handleOtpSubmit("finalOwner")}
                    >
                      Submit
                    </Button>
                  </Typography>
                </Grid>
              </Grid>
            )} */}
          </MainCard>
        </Grid>
      </Grid>
    </>
  );
}
export default TagDeviceToVehicle;
